import * as React from "react";
import "./style.scss";

function Tooltip({ copywriting, anchor, isActive, callback, tooltipRef, additionalClasses }) {
  React.useEffect(() => {
    const handleClickOutside = event => {
      const target = event.target;

      if (!tooltipRef?.current || tooltipRef?.current?.contains(target)) return;

      callback(event);
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [tooltipRef, callback]);

  return (
    <span className={`tooltip-container ${isActive ? "active" : ""}`}>
      <span className={`tooltip-text ${additionalClasses}`}>{copywriting}</span>
      {anchor}
    </span>
  );
}

export default Tooltip;
